import { t$2 } from '@/js/global/global'
import { shouldAnimate, getMediaQuery } from '@/js/global/helpers'
import { backgroundVideoHandler } from '@/js/global/a11y-user'
import { register } from '@/js/global/shopify-theme-sections'
import { playButton, autoPlay } from '@/js/global/video-helpers'
import { animateVideoHero } from '@/js/global/animations'

const selectors$g = {
  video: "[js-data-background-video]",
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};

register("video-hero", {
  videoHandler: null,

  onLoad() {
    const playButtonVideos = t$2(selectors$g.playButtonVideo, this.container);
    const videos = t$2(selectors$g.video, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block => playButton(block.closest(selectors$g.playButtonBlock)));
    }

    if (videos.length) {
      this.handleVideoPlayers(videos);

      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.handleVideoPlayers(videos, true);
        }, 1000);
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateVideoHero = animateVideoHero(this.container);
    }
  },

  handleVideoPlayers(videos, resize = false) {
    let mobileVideo;
    let desktopVideo;

    videos.forEach(video => {
      this.videoHandler = backgroundVideoHandler(video.parentNode);

      if (video.classList.contains('video-hero__video--mobile')) {
        mobileVideo = video;
      }

      if (video.classList.contains('video-hero__video--desktop')) {
        desktopVideo = video;
      }
    });

    if (window.matchMedia(getMediaQuery("below-720")).matches) {
      if (mobileVideo) {
        if (resize) {
          mobileVideo.play();
        } else {
          autoPlay(mobileVideo);
        }
      }

      if (desktopVideo) desktopVideo.pause();
    }

    if (window.matchMedia(getMediaQuery("above-720")).matches) {
      if (desktopVideo) {
        if (resize) {
          desktopVideo.play();
        } else {
          autoPlay(desktopVideo);
        }
      }

      if (mobileVideo) mobileVideo.pause();
    }
  },

  onUnload() {
    var _this$animateVideoHer;

    this.playButtons && this.playButtons.forEach(button => button.unload());

    this.videoHandler && this.videoHandler();

    (_this$animateVideoHer = this.animateVideoHero) === null || _this$animateVideoHer === void 0 ? void 0 : _this$animateVideoHer.destroy();
  }
});
